import { Button } from "components/button";
import React, { useState } from "react";
import { useAppSelector } from "store/hooks";
import {
  selectAllCertificateTypes,
  useCreateCertificateTypeMutation,
  useDeleteCertificateTypeMutation,
} from "store/reducers/certificateType";

export function Certifications() {
  const [certificateTypeName, setCertificateTypeName] = useState("");

  const certificateTypes = useAppSelector(selectAllCertificateTypes);

  const [createCertificateType, { isLoading: isCreating }] = useCreateCertificateTypeMutation();
  const [deleteCertificateType, { isLoading: isDeleting }] = useDeleteCertificateTypeMutation();

  function handleCreate() {
    if (!certificateTypeName) return;
    createCertificateType({ name: certificateTypeName.trim() });
    setCertificateTypeName("");
  }

  function handleDelete(certificateTypeId: number) {
    deleteCertificateType({ certificate_type_id: certificateTypeId });
  }

  return (
    <div className="my-3">
      <label className="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2">
        Create a new certificate type
      </label>
      <div className="flex my-3 w-1/2">
        <input
          className="appearance-none block w-full bg-grey-lighter text-grey-darker border border-primary-light rounded-l py-3 px-4 focus:outline-none focus:ring"
          value={certificateTypeName}
          onChange={(e) => setCertificateTypeName(e.target.value)}
          placeholder="Enter certificate type name"
        />
        <Button colour="accent" onClick={handleCreate} disabled={isCreating}>
          {isCreating ? "Creating..." : "Create"}
        </Button>
      </div>

      {certificateTypes.length > 0 && (
        <table className="table">
          <thead>
            <tr>
              <th colSpan={2} className="table-header-name">
                Existing Certificate Types
              </th>
            </tr>
            <tr>
              <th className="table-header-column-name">Name</th>
              <th className="table-header-column-name">Action</th>
            </tr>
          </thead>
          <tbody>
            {certificateTypes.map((certificate) => (
              <tr key={certificate.id}>
                <td className="table-body-cell">{certificate.name}</td>
                <td className="table-body-cell">
                  <Button colour="danger" onClick={() => handleDelete(certificate.id)}>
                    {isDeleting ? "Deleting..." : "Delete"}
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {certificateTypes.length === 0 && <p>No certificate types found</p>}
    </div>
  );
}
